export default __webpack_public_path__ + "static/genova-scheda-tecnica-c8492194588db41d90f0a219574ba5a1.pdf";